import { ChevronDown, ChevronUp } from "lucide-react";

/**
 * Collapsible Accordion component
 * Used for category groupings and room details
 */
export const Accordion = ({ 
  id,
  title,
  emoji = null,
  badge = null,
  isExpanded,
  onToggle,
  children,
  testIdPrefix = "accordion"
}) => {
  return (
    <div 
      className="bg-gray-50 rounded-xl overflow-hidden border border-gray-200"
      data-testid={`${testIdPrefix}-group-${id}`}
    >
      {/* Header - Clickable to expand/collapse */}
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-gray-100 transition-colors"
        data-testid={`${testIdPrefix}-toggle-${id}`}
      >
        <div className="flex items-center gap-3">
          {emoji && <span className="text-xl">{emoji}</span>}
          <span className="font-semibold text-[#1F2933]">{title}</span>
          {badge && (
            <span className="bg-[#0FA3B1] text-white text-xs px-2 py-0.5 rounded-full">
              {badge}
            </span>
          )}
        </div>
        {isExpanded ? (
          <ChevronUp className="w-5 h-5 text-[#1F2933]/50" />
        ) : (
          <ChevronDown className="w-5 h-5 text-[#1F2933]/50" />
        )}
      </button>
      
      {/* Content - Shown when expanded */}
      {isExpanded && (
        <div className="border-t border-gray-200 bg-white">
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
